// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rounded-btn{border-radius:.25rem}", "",{"version":3,"sources":["webpack://./Themes/Storefront/resources/assets/public/js/components/account/profile/ProfileDetails.vue"],"names":[],"mappings":"AACA,aACE,oBAAF","sourcesContent":["\n.rounded-btn {\n  border-radius: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
